import "./CreatorTable.css";

export default function CreatorTable({ data, columns, onSelect }) {
  return (
    <div className="tableWrapper">
      <div className="tableHeader">
        {columns.map(col => (
          <div key={col.key}>{col.label}</div>
        ))}
      </div>
      {data.map((item, idx) => (
        <div
          key={item.id || idx}
          className="row"
          onClick={() => onSelect && onSelect(item)}
        >
          {columns.map(col => (
            <div key={col.key}>
              {col.render ? col.render(item[col.key], item) : item[col.key]}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}

/* Utility helpers */
export function formatNumber(num) {
  if (!num) return "0";
  if (num >= 1000000) return (num / 1000000).toFixed(1) + "M";
  if (num >= 1000) return (num / 1000).toFixed(1) + "K";
  return num;
}

export function scoreColor(score) {
  if (score >= 90) return "green";
  if (score >= 75) return "orange";
  return "red";
}
